import { IVentureBase } from '../../models/ventures';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListVenturesProps {
  cnpj?: string;
  email?: string;
  name?: string;
  phone?: string;
  sort?: 'cnpj' | 'name' | 'phone' | 'email' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

export type IVentureListItem = IVentureBase;

export type IVentureList = IListResponse<IVentureListItem>;

export const listVenturesService = async (
  filters?: IListVenturesProps,
): Promise<IVentureList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          cnpj: filters.cnpj || undefined,
          email: filters.email || undefined,
          name: filters.name || undefined,
          phone: filters.phone || undefined,
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IVentureList>('/ventures', {
    params,
  });

  return data;
};
